var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrapper"},[_c('img',{attrs:{"src":require("@/assets/images/title_decoration_left.png"),"alt":"装饰left"}}),_c('div',{staticClass:"report-name"},[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@/assets/images/title_decoration_right.png"),"alt":"装饰right"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }